import React from 'react';
import styled from 'styled-components';
import useArrayToggler, {
  ArrayTogglerBehaviorTypes,
} from '../../../../../shared/hooks/useArrayToggler';

export interface IQuickFilters<T extends unknown, K extends keyof T> {
  data: T[];
  actionHandler: (data: T[], itemUnderAction: T) => void;
  lookup: (item: T) => T[K] | T;
  defaultState?: T[];
}

function QuickFiltersUI<T extends unknown, K extends keyof T>(props: IQuickFilters<T, K>) {
  const {data, lookup, actionHandler, defaultState} = props;
  const [isChecked, onClickHandler] = useArrayToggler(
    data,
    lookup,
    ArrayTogglerBehaviorTypes.multiSelect,
    actionHandler,
    defaultState,
  );
  return (
    <>
      {data.map((item, index) => (
        <WrapperDiv
          key={index + 'quickFilterItem'}
          onClick={() => onClickHandler(item)}
          isChecked={isChecked(item)}
        >
          <TextWrapperSpan>{item.n}</TextWrapperSpan>
        </WrapperDiv>
      ))}
    </>
  );
}

export default QuickFiltersUI;

export const WrapperDiv = styled.div<{isChecked: boolean}>(
  props => `
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goBrandBlue.light};
  padding: ${props.theme.spacing.custom(8)} ${props.theme.spacing.base};
  border-radius: ${props.theme.misc.borderRadius.xlarge};
  margin-right: ${props.theme.spacing.custom(8)};
  cursor: pointer;
  background-color: ${(props.isChecked && props.theme.colors.goBrandBlue.base) ||
    props.theme.colors.goWhite.base};
  color: ${(props.isChecked && props.theme.colors.goWhite.base) ||
    props.theme.colors.goBrandBlue.base};
  z-index: ${props.theme.misc.zIndex.large};
  `,
);

export const TextWrapperSpan = styled.span(
  props => `
  padding-right: ${props.theme.spacing.small};
`,
);
